import { t } from 'Src/i18n';
import { POOL_HEATING_DESCRIPTION } from 'Views/booking/constants';
type List = Array<{
  label?: string;
  value: string | null | undefined;
}>;
const LABELS = {
  GOLF_HOLES_NUMBER: 'common.activities.holesNumber',
  GOLF_INDEX: 'common.activities.index',
  GOLF_PAR: 'common.activities.par',
  POOL_HEATING_DESCRIPTION: 'common.heated',
};
export const getFacilityHeatedLabel = ({
  isHeated,
  hasPoolHeatingDescription,
}: {
  isHeated: boolean;
  hasPoolHeatingDescription: boolean;
}) => {
  if (!hasPoolHeatingDescription && isHeated) {
    return t('common.heated');
  }

  return null;
};
export const getFacilityInfoList = (facility: FacilityEntity): List => {
  const {
    distanceAndTransferDescription,
    hasFreeAccess,
    hasNightLighting,
    level,
    localisation,
    openingHours,
    specificInformation,
    technicalSpecificities,
    isOutdoor,
  } = facility || {};
  const hasPoolHeatingDescription = (specificInformation || []).some(
    (el) => el.type === POOL_HEATING_DESCRIPTION,
  );
  const facilityHeatedLabel = getFacilityHeatedLabel({
    isHeated: technicalSpecificities.isHeated,
    hasPoolHeatingDescription,
  });
  const list: List = [
    {
      value: isOutdoor === null ? '' : t(`common.${isOutdoor ? 'outdoor' : 'indoor'}`),
    },
    {
      value: distanceAndTransferDescription,
    },
    {
      value: hasFreeAccess ? t('common.freeAccess') : null,
    },
    {
      value: hasNightLighting ? t('common.nightLighting') : null,
    },
    {
      value: facilityHeatedLabel,
    },
    {
      value: level,
    },
    {
      value: localisation,
    },
    {
      value: (openingHours || [])
        .map(({ closing, opening }) => [opening, closing].join(' - '))
        .join(', '),
    },
    ...(specificInformation || []).map(({ type, value }) => ({
      label: LABELS[type] ? t(LABELS[type]) : '',
      value,
    })),
    {
      value: (technicalSpecificities?.typesDescription || []).join(', '),
    },
    ...Object.entries(technicalSpecificities)
      .filter(([key, value]) => !['isHeated', 'unit', 'typesDescription'].includes(key) && value)
      .map(([key, value]) => ({
        label: t(`common.${key}`),
        value: `${value}${technicalSpecificities.unit}`,
      })),
  ];
  return list.filter((l) => Boolean(l.value));
};
